import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                validateButton: 'validate'
            }
        }
    }

    init() {
        
        this.ageGateValid = sessionStorage.getItem('ageGate');

        if(this.ageGateValid != null) {
            this.validate();
        }

    }

    validate() {
        
        sessionStorage.setItem('ageGate','valid');

        html.classList.add('has-age-gate-valid');
        // this.call('launch','HomeHero');

        html.classList.add('is-ready');

        if(!html.classList.contains('has-transition')) {
            gsap.delayedCall(1.2, () => {
                html.classList.add('has-age-gate-valid-callback');
                html.classList.add('has-dom-ready');

                gsap.delayedCall(0.6, () => {
                    html.classList.add('has-dom-ready-callback');
                });
                
                html.classList.add('has-age-gate-validated');
            })
        } else {
            // if transition is currently happening
            gsap.delayedCall(0.6, () => {
                html.classList.add('has-dom-ready');

                gsap.delayedCall(0.6, () => {
                    html.classList.add('has-dom-ready-callback');
                });
            })
        }

        // if home carousel exist, launch it
        if(this.modules.HomeHero != undefined) {
            gsap.delayedCall(0.6, () => {
                this.call('launch','HomeHero');
            });
        }
        
    }
}
